import { prematchPrefix } from '../../Container';
import { getLabel } from '../../InitData';
import MenuContainer from '../menu/MenuContainer';
import SidebarLink from './SidebarLink';

export default function LeftSidebar(props) {
    return (
        <div className="c_8_1">
            {props.children}
            <MenuContainer title={getLabel('general.extras')}>
                {/* <SidebarDropdown icon={'icon_allsports.svg'} text={'Odds format'} /> */}
                <SidebarLink href={`${prematchPrefix}/statistics`} icon={'icon_allsports.svg'} text={getLabel('general.statistics')} />
                <SidebarLink href={`${prematchPrefix}/results`} icon={'icon_allsports.svg'} text={getLabel('general.results')} />
            </MenuContainer>
        </div>
    );
}
